exports.components = {
  "component---src-page-templates-contact-tsx": () => import("./../../../src/page-templates/contact.tsx" /* webpackChunkName: "component---src-page-templates-contact-tsx" */),
  "component---src-page-templates-index-tsx": () => import("./../../../src/page-templates/index.tsx" /* webpackChunkName: "component---src-page-templates-index-tsx" */),
  "component---src-page-templates-page-tsx": () => import("./../../../src/page-templates/page.tsx" /* webpackChunkName: "component---src-page-templates-page-tsx" */)
}

